import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CareIcon = ({
  width = 32,
  height = 32,
  checkColor,
  backgroundColor,
  ...rest
}: {
  width?: number;
  height?: number;
  checkColor?: string;
  backgroundColor?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken();

  const currentCheckColor = checkColor ?? token.colorText;
  const currentBackgroundColor = backgroundColor ?? (token as CustomThemeToken).colorIR;
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M17.4424 24.6895L15.786 27.2325L14.0624 24.7286L5.09424 11.6998H10.0205L15.6956 19.945L26.422 3.76784C23.6253 1.41852 20.014 0 16.0686 0C7.194 0 0 7.16351 0 16C0 24.8365 7.194 32 16.0686 32C24.943 32 32.1374 24.8365 32.1374 16C32.1374 12.6066 31.0738 9.46254 29.2646 6.87382L17.4424 24.6895Z"
        fill={currentBackgroundColor}
      />
      <path
        d="M10.0215 11.7H5.0957L14.0639 24.7283L15.787 27.2322L17.4439 24.6892L29.2656 6.87404C28.458 5.71795 27.5017 4.67354 26.4235 3.76758L15.6971 19.9447L10.0215 11.7Z"
        fill={currentCheckColor}
      />
    </svg>
  );
};

export default CareIcon;
